
    Vue.directive('lazyload', {
        inserted: el => {
          function loadImage() {
            const imageElements = el.querySelectorAll('img');

            if (imageElements.length > 0) {
                imageElements.forEach((imageElement) => {
                    imageElement.addEventListener("load", () => {
                      setTimeout(() => el.classList.add("loaded"), 100);
                    });
                    imageElement.addEventListener("error", () => console.log("error"));
                    imageElement.src = imageElement.dataset.src;
                    imageElement.parentElement.parentElement.classList.add('ready');
                });
            }
          }
      
          function handleIntersect(entries, observer) {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                loadImage();
                observer.unobserve(el);
              }
            });
          }
      
          function createObserver() {
            const options = {
              root: null,
              threshold: "0"
            };
            const observer = new IntersectionObserver(handleIntersect, options);
            observer.observe(el);
          }
          if (window["IntersectionObserver"]) {
            createObserver();
          } else {
            loadImage();
          }
        }
    });

    Vue.directive('intersect', {
        inserted: el => {
          function triggerSlick() {
            const isMobile = window.innerWidth < 769;
            
            setTimeout(function(){
              const $imgList = el.querySelector('.image-list.ready');
              // $($imgList).slick({
              //   draggable: true,
              //   dots: true,
              //   arrows: false
              // });

            }, 600);
            // console.log('Trigger Slick', isMobile, el);
          }
      
          function handleIntersect(entries, observer) {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                triggerSlick();
                observer.unobserve(el);
              }
            });
          }
      
          function createObserver() {
            const options = {
              root: null,
              threshold: "0"
            };
            const observer = new IntersectionObserver(handleIntersect, options);
            observer.observe(el);
          }
          if (window["IntersectionObserver"]) {
            createObserver();
          } else {
            loadImage();
          }
        }
    });

    Vue.directive('auto-click', {
        inserted: el => {
          function autoClick() {
            el.click();
          }
      
          function handleIntersect(entries, observer) {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                // console.log('Autoclick!');
                autoClick();
                // observer.unobserve(el);
              }
            });
          }

          // console.log('Setup Auto Click', el);
      
          function createObserver() {
            const options = {
              root: null,
              threshold: "0"
            };
            const observer = new IntersectionObserver(handleIntersect, options);
            observer.observe(el);
          }
          if (window["IntersectionObserver"]) {
            createObserver();
          }
        }
    });